import { combineReducers } from 'redux';
import user from './user/reducers';
import tasks from './tasks/reducers';
import general from './general/reducers';
import common from './common/reducers';

export const rootReducer = combineReducers({
    user, tasks, general, common
});